import { makeSelectors } from '@utils/css';

const badgeTransitionDurationMs = 100;
const modifiers = makeSelectors({
  longTitle: "_61l4q97on"
});
const linkCls = "_61l154x4bg";
const revisionBadge = "_61rjde389";
const vignetteCls = "_61v1nhkcqk";
const headingCls = "_61hczk7n";
const vignetteAspectRatioCls = "_61v1bjtg0v";
const img = "_61i1mdz146";

export { badgeTransitionDurationMs, headingCls, img, linkCls, modifiers, revisionBadge, vignetteAspectRatioCls, vignetteCls };
import "./nav-header.style.linaria.module.css";
//# sourceMappingURL=nav-header.style.js.map
